var _radialGradient, _path, _circle, _linearGradient, _circle2, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _circle3, _linearGradient7, _circle4, _linearGradient8, _circle5, _linearGradient9, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Work(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrba",
    cx: 36.884,
    cy: 11.248,
    r: 14.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#787f85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#7a8187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#90989f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#9da5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a1aab3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CHuzbYsr5qCGlr1MNTdrba)",
    d: "M27.318,14.318c-0.352,0.352-20.648,20.648-21,21c-1.757,1.757-1.757,4.607,0,6.364 c1.757,1.757,4.607,1.757,6.364,0c0.352-0.352,20.648-20.648,21-21L27.318,14.318z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 38,
    r: 3,
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbb",
    x1: 8.129,
    x2: 11.411,
    y1: 36.129,
    y2: 39.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 38,
    r: 2,
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbb)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbc",
    x1: 29.131,
    x2: 41.661,
    y1: 6.002,
    y2: 18.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbc)",
    d: "M40.425,12.838c-1.453,1.453-3.81,1.453-5.263,0c-1.453-1.453-1.453-3.81,0-5.263 c0.355-0.355,1.784-1.784,3.24-3.24c0.349-0.349,0.194-0.959-0.285-1.077c-1.18-0.29-2.45-0.351-3.771-0.102 c-3.874,0.73-6.895,3.972-7.297,7.893c-0.586,5.718,4.186,10.489,9.904,9.902c3.921-0.403,7.162-3.424,7.892-7.298 c0.249-1.321,0.188-2.59-0.102-3.77c-0.118-0.48-0.728-0.635-1.077-0.285C42.209,11.054,40.78,12.484,40.425,12.838z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbd",
    x1: 14.679,
    x2: 23.597,
    y1: 13.564,
    y2: 40.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbd)",
    d: "M16.705,38.237L6.524,28.3l0.291-7.883l5.775-5.785l5.49-1.402L26,15.636l-2.445,2.445 l8.591,8.824L16.705,38.237z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbe",
    x1: 20.469,
    x2: 29.385,
    y1: 12.308,
    y2: 39.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbe)",
    d: "M27,29c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S28.657,29,27,29z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbf",
    x1: 23.469,
    x2: 32.385,
    y1: 9.308,
    y2: 36.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbf)",
    d: "M30,26c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S31.657,26,30,26z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbg",
    x1: 16.019,
    x2: 24.935,
    y1: 13.95,
    y2: 40.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 35,
    r: 3,
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbg)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbh",
    x1: 7.437,
    x2: 18.334,
    y1: 15.264,
    y2: 48.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 24.5,
    r: 5.5,
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbh)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbi",
    x1: 13.437,
    x2: 24.334,
    y1: 9.264,
    y2: 42.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 18.5,
    r: 5.5,
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbi)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CHuzbYsr5qCGlr1MNTdrbj",
    x1: 10.409,
    x2: 20.316,
    y1: 12.104,
    y2: 41.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 36.5,
    r: 2.5,
    fill: "url(#CHuzbYsr5qCGlr1MNTdrbj)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Work);
export default __webpack_public_path__ + "static/media/icons8-work.c73a6eb6734f0dc754ee164b9969c27d.svg";
export { ForwardRef as ReactComponent };